var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import tw from 'tailwind-styled-components';
export var Wrapper = tw.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex flex-row items-center gap-10\n"], ["\n  flex flex-row items-center gap-10\n"])));
export var IconLink = tw.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-white\n"], ["\n  text-white\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=SocialButtons.styled.js.map